import { useMemo } from 'react';
import { useAppContainerContext } from '../AppContainerContext';

type ChatEmptyMessage = {
  title: string;
  subtitle: string;
};

const CHAT_EMPTY_MESSAGES: Record<string, ChatEmptyMessage> = {
  'suitability-report-edit': {
    title: 'Chat mode activated',
    subtitle:
      "Ask anything about editing this document — structure, wording, improvements and more. I'm here to help.",
  },
  default: {
    title: 'Chat mode activated',
    subtitle:
      'Ask me anything about this page. I can help analyze, summarize, or answer questions.',
  },
};

export function useChatEmptyMessage(): ChatEmptyMessage {
  const { contentMeta } = useAppContainerContext();
  const pageType = contentMeta?.pageType;

  return useMemo(() => {
    if (pageType && CHAT_EMPTY_MESSAGES[pageType]) {
      return CHAT_EMPTY_MESSAGES[pageType];
    }
    return CHAT_EMPTY_MESSAGES.default;
  }, [pageType]);
}
